import React from 'react';

const CommissionEntry = (props) => (
	

    <tr  onClick={props.status === "COMPLETED" ?props.onClick: ""} className={props.className+'tr'}>
        <td className={props.className === "commission-selector-entry" && props.status === "COMPLETED"?props.className+"-clickable":props.className}>{props.commission_name}</td>
        <td className={props.className}>{props.class_period_start}</td>
        <td className={props.className}>{props.class_period_end}</td>
        <td className={props.className}>{props.date_commissioned}</td>
        <td className={props.className}>{props.cusip}</td>
        <td className={props.className}>{props.status}</td>
    </tr>
);

export default CommissionEntry;


// WEBPACK FOOTER //
// ./src/commissions/components/CommissionEntry.js